import React, { useEffect } from "react";
import CommonModal from "../../../../../../Modals/CommonModal";
import LightboxContent from "./LightboxContent";
import "./LightBoxSection.css";

const ViewLightBox = ({ showLightBox, setShowLightBox, videoMonitor = null }) => {
    useEffect(() => {
        const handleEscPress = (event) => {
            if (event.key === "Escape") {
                event.stopPropagation();
                event.preventDefault();
                setShowLightBox(null);
            }
        };

        if (showLightBox) {
            document.addEventListener("keydown", handleEscPress, true);
        }

        return () => {
            document.removeEventListener("keydown", handleEscPress, true);
        };
    }, [showLightBox]);

    return (
        <CommonModal
            modalStatus={showLightBox != null}
            changeActiveStatus={() => setShowLightBox(null)}
            centered
            lightBox={true}
            onClick={(e) => e.stopPropagation()}
        >
            <LightboxContent lightbox={showLightBox} videoMonitor={videoMonitor} />
        </CommonModal>
    );
};

export default ViewLightBox;
